import type { ReactNode } from 'react'
import styled from 'styled-components'

type TalkListProps = {
  talkTitle: string
  talkList: {
    id: string
    nameColor: string
    name: string
    talkContent: ReactNode
  }[]
}

export const TalkList = ({ talkTitle, talkList }: TalkListProps) => {
  return (
    <TalkListStyled>
      <TalkTitle>{talkTitle}</TalkTitle>
      {talkList.map(({ id, nameColor, name, talkContent }) => (
        <TalkContent key={id} color={nameColor}>
          <p>{name}：</p>
          <p>{talkContent}</p>
        </TalkContent>
      ))}
    </TalkListStyled>
  )
}

const TalkListStyled = styled.div`
  padding-bottom: 90px;

  &:last-child {
    padding-bottom: 0;
  }

  @media screen and (max-width: 1047px) {
    padding-bottom: 46px;
  }
`

const TalkTitle = styled.h4`
  font-weight: bold;
  font-size: 26px;
  border-bottom: 1px solid #c0c0c0;
  padding-bottom: 20px;
  position: relative;

  @media screen and (max-width: 1047px) {
    font-size: 20px;
    padding-bottom: 12px;

    &::after {
      top: 44%;
    }
  }
`

const TalkContent = styled.div<{ color: string }>`
  display: flex;
  gap: 15px;
  padding-top: 40px;

  p {
    font-size: 18px;
    line-height: 1.8;
  }

  p:nth-of-type(1) {
    color: ${({ color }) => color};
    white-space: nowrap;
    font-weight: bold;
  }

  @media screen and (max-width: 1047px) {
    padding-top: 24px;
    gap: 5px;

    p {
      font-size: 14px;
    }
  }
`
